import * as actionTypes from '../../store/actions/ActionTypes';
import baseService from '../BaseService';
import Config from '../../utils/Configuration';

const getFooterInfo = ({lang = 'en'}) => {
    return fetch(`${Config.apiConfig.webURL}/${lang}/newglobalfooter/`).then((res) => res.text());
};

const getFooterSuccess = (res) => {
    return res || "";
};

export const getFooter = () => {
    return async (dispatch) => {
        return baseService.serviceRequest(
            {},
            dispatch,
            getFooterInfo,
            {
                lang: navigator.languages && navigator.languages[0].toLowerCase().includes('ms') ? 'ms' : 'en'
            },
            actionTypes.GET_FOOTER,
            (res) => getFooterSuccess(res)
        );
    };
};

const getHeaderInfo = ({lang = 'en'}) => {
    return fetch(`${Config.apiConfig.webURL}/${lang}/newglobalheader/`).then((res) => res.text());
};

const getHeaderSuccess = (res) => {
    return res || "";
};

export const getHeader = (lang) => {
    return async (dispatch) => {
        return baseService.serviceRequest(
            {},
            dispatch,
            getHeaderInfo,
            {
                lang: navigator.languages && navigator.languages[0].toLowerCase().includes('ms') ? 'ms' : 'en'
            },
            actionTypes.GET_HEADER,
            (res) => getHeaderSuccess(res)
        );
    };
};

const getHeaderFooterInfo = () => {
    return fetch(`${Config.apiConfig.aemEndPoint}/bin/global/enterpriseheaderfooter.json`).then((res) => res.json());
};

const getHeaderFooterSuccess = (res) => {
    return res || {};
};

export const getHeaderFooter = () => {
    return async (dispatch) => {
        return baseService.serviceRequest({}, dispatch, getHeaderFooterInfo, {}, actionTypes.GET_HEADER_FOOTER, (res) =>
            getHeaderFooterSuccess(res)
        );
    };
};
